<div class="container">
  <div class="close-btn" (click)="closeModal()">
    <span class="cmx-icon-close"></span>
  </div>
  <div class="container-fluid">
    <ng-container>
      <div>
        <span class="cmx-icon-warning-rounded-fill" aria-hidden="true"> </span>
      </div>
      <div>
        <span class="text-label">{{ warningText }}</span>
      </div>
    </ng-container>
  </div>

  <div class="actions">
    <cwc-button cmx-button (click)="closeModal()" color="secondary" designVersion="v2">
      {{ 'views.globals.lblOk' | translate }}
    </cwc-button>
  </div>
</div>
